import React from 'react'

import { useEffect } from 'modules/core/hooks/useEffect'

const PIXEL_SIZE = 5.8
const DEFAULT_PADDING = 22
const DEFAULT_PIXEL_SIZE = 10

const useMarginEffect = (length: number) => {
  const [left, setLeft] = React.useState(0)

  useEffect(() => {
    const pixel =
      Math.round(Math.log10(length < DEFAULT_PIXEL_SIZE ? DEFAULT_PIXEL_SIZE : length)) * PIXEL_SIZE
    const marginSize = Math.round(pixel)

    setLeft(DEFAULT_PADDING + marginSize)
  }, [length])

  return left
}

export default useMarginEffect
